export enum FeatureFlag {
    PersistentSearch = 'S_PersistentSearch',
    ChromaticMS2 = 'CH_ChromaticMS2',
}
